<template>
  <list-dashboards titleSmartsheet="Pmgd" :typeSmartsheet="SMARTSHEET_TYPES.pmgd">
  
  </list-dashboards>
</template>

<script>
import ListDashboards from '../../../components/smartsheet/ListDashboards.vue'
import { SMARTSHEET_TYPES } from '@/constants/smartsheet'

export default {
  components: { ListDashboards },
  data(){
    return {
      SMARTSHEET_TYPES
    }
  }
}
</script>

<style>

</style>